<mat-sidenav [opened]="false" mode="over" #sidenav class="sidenav mat-elevation-z6 zindex sidenav-overflow">
    <div [ngStyle]=" {'background':settings.theme}" class="pt-8 sideDiv">
        <button mat-icon-button color="warn" class="close bg-wht" (click)="sidenav.close()">
            <i class="material-icons warn" data-icon="close"></i>
        </button>
        <img *ngIf="!loggedIn" class="profile" alt="Profile" src="assets/images/default-avatar.png">
        <div class="avatar" *ngIf="loggedIn">
            {{userDetails['first_name'] | slice: 0: 1 | titlecase}}{{userDetails['last_name'] | slice: 0: 1 |
            titlecase}}
        </div>
        <h5 *ngIf="loggedIn === true" class="name">{{userDetails['first_name']}} {{userDetails['last_name']}}</h5>
    </div>
    <div class="mob-search">
        <form [formGroup]="searchForm" class="search-form" fxLayout="row">
            <input type="text" placeholder="Type to search..." fxFlex (keydown.enter)="mobileSearch(searchForm.value)"
                formControlName="keyword">
            <button mat-mini-fab (click)="mobileSearch(searchForm.value)" matTooltip="search products" type="button"
                class="search-btn mat-elevation-z0 text-muted">
                <i class="material-icons" data-icon="search"></i>
            </button>
        </form>
    </div>

    <div *ngIf="Menus['sortedLinks']">
        <ng-container *ngIf="featureTags && this.featureTags['sf_desktop_sub_cat']">
            <ng-container *ngIf="featureTags && !featureTags['sf_side_menu_global_change']">
            <div *ngIf="categories?.length > 0">
                <app-sidenav-menu [menuItems]="categories" [menuParentId]="0"
                    (emitPass)="handleChange($event)"></app-sidenav-menu>
            </div>
            </ng-container>
            <ng-container *ngIf="featureTags && featureTags['sf_side_menu_global_change']">
            <div *ngIf="categories?.length > 0 && sidenavMenuItems['desktop_links']">
                <app-sidenav-menu [menuItems]="categories" [menuParentId]="0" [accountMenuItems]="sidenavMenuItems" 
                (emitPass)="handleChange($event)"></app-sidenav-menu>                        
            </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="featureTags && !this.featureTags['sf_desktop_sub_cat']">
            <app-sidenav-menu *ngFor="let sideNav of MenusHeight['sortedHeight']" [menuItems]="sideNav"
                [menuParentId]="0" (emitPass)="handleChange($event)">
            </app-sidenav-menu>
        </ng-container>
    <ng-container *ngIf="featureTags && !this.featureTags['sf_side_menu_global_change']">
        <div *ngFor="let menuItem of sidenavMenuItems['desktop_links']">
            <div *ngIf="menuItem['title']['display']">
                <a mat-button *ngIf="menuItem['title']['display']['desktop'] === true" fxLayout="row"
                    fxLayoutAlign="start center" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                    (click)="handleChange(menuItem)"
                    [ngClass]="!!menuItem['title']['cssClass'] ? menuItem['title']['cssClass'] : ''">
                    <span *ngIf="menuItem['title']['type'] === 'public'" class="text-uppercase menu-title1"
                        [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check1</span>
                    <span *ngIf="menuItem['title']['type'] === 'private' && loggedIn" class="text-uppercase menu-title1"
                        [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check2</span>
                </a>
                <div class="menu-item" *ngFor="let subLinks of menuItem['links']"
                    [class.active]="router.url === '/'+subLinks.href">
                    <a mat-button *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true" fxLayout="row"
                        fxLayoutAlign="start center" class="pl-0" routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{exact:true}" (click)="handleChange(subLinks)">
                        <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                            *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                        <span *ngIf="subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' "
                            class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                        <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                            *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                        <span *ngIf="subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn"
                            class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                        <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                            *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                        <span *ngIf="subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase"
                            [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="menu-item">
            <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0  bo-5 " [routerLink]="['/contact']">
                <span>CONTACT US</span>
            </a>
        </div>
    </ng-container>
        </div>
        <div class="divider"></div>
        <div class="text-center py-1 socialIconsSN" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <a *ngFor="let SI of storeDetailsJson['socialMedia']" [href]="SI.href" target="_blank">
                <i [class]="'fa fa-'+SI.icon"></i>
            </a>
        </div>
    </mat-sidenav>

<!-- HudsonMilk Header Start -->
<!-- <h1>==========HEADER===============</h1> -->
<div class="hudsonMilkTheme">
    <mat-toolbar class="hudsonThemeHeader">
        <div class="searchProducts" *ngIf="isShowSearch">
            <div fxFlex="96%" fxFlex.gt-sm="50%" fxShow.gt-sm>
                <app-search-products #searchProductsInDesktopView [store]="storeDetails" [user]="userDetails"
                    [showSearchResult]="showSearchProductsResult"></app-search-products>
            </div>
            <!-- <div class="inputGrp">
                <input type="search">
                <div class="actionSearch">
                    <i class="fa fa-search"></i>
                    <button type="button" (click)="SearchProductsFn()">Cancel</button>
                </div>
            </div> -->
        </div>
        <app-cc-alert></app-cc-alert>
        <mat-toolbar-row class="toolbarBg" fxHide.xs>
            <div class="containerLg containerLgMbl" fxLayoutAlign="space-between center" #top>
                <span class="btnNavIcon" fxHide.gt-md>
                    <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle menuBtn">
                        <i class="material-icons md-36" data-icon="menu"></i>
                    </button>
                </span>
                <a class="telInfo" href="tel:+{{storeDetails['phone'] | phone: 'US'}}" fxLayoutAlign="center center">
                    <i class="material-icons md-18 " data-icon="call"></i>
                    {{storeDetails['phone'] | phone: 'US'}}
                </a>
                <span fxHide.lt-md class="welTxt" style="font-weight: 600;"
                    *ngIf="storeDetailsJson['header']">{{storeDetailsJson['header']['welcomeText']}}</span>
                <div class="socialIcons SIHeader">
                    <ul class="list-inline" fxLayout="row" fxLayoutGap="15px">
                        <li *ngFor="let x of storeDetailsJson['socialMedia']">
                            <a [href]="x.href" target="_blank">
                                <i [class]="'fa fa-'+x.icon" aria-label="Socialmedia"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-toolbar-row>
        <mat-toolbar-row class="headerLogo" fxShow.gt-sm>
            <div class="containerLg" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout.xs="row" fxLayoutAlign.xs="space-between center" fxFlex.xs="100">
                    <div fxHide.gt-xs fxLayout.xs="row" fxLayoutAlign.xs="space-between center" [fxLayoutGap.xs]="shouldAddGap ? '10px' : null">
                        <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle menuBtn">
                            <i class="material-icons md-36" data-icon="menu"></i>
                        </button>
                        <button (click)="SearchProductsFn()" mat-icon-button
                            aria-label="Example icon button with a vertical three dot icon">
                            <i class="fa fa-search" style="font-size: 25px;"></i>
                        </button>
                    </div>
                    <div *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                        <a *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] === ''"
                            class="logo" routerLink="" (click)="closeSubMenus()">
                            {{storeDetailsJson['header']['logoText']}}
                        </a>
                        <a fxLayout="row"
                            *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] !== ''"
                            (click)="closeSubMenus()" routerLink="">
                            <img [src]="storeDetailsJson['header']['logoImage']" class="brandLogo" alt="Logo"
                                [ngStyle]="{'background': storeDetailsJson['settings']['imageBackground']}" />
                        </a>
                    </div>
                    <div *ngIf="!!featureTags && featureTags['sf_cms_images']">
                        <!-- <a *ngIf="storeDetailsJson['header']"
                            class="logo" routerLink="" (click)="closeSubMenus()">
                            {{storeDetailsJson['header']['logoText']}}
                        </a> -->
                        <a fxLayout="row"
                            (click)="closeSubMenus()" routerLink="">
                            <img src="assets/hudson/files/images/3/content-images/logo.jpg" class="brandLogo" alt="Logo"
                                [ngStyle]="{'background': storeDetailsJson['settings']['imageBackground']}" />
                        </a>
                    </div>
                    <div fxHide.gt-xs>
                        <app-top-menu *ngIf="sidenavMenuItems['desktop_links']"
                            [menuItems]="sidenavMenuItems['desktop_links']" [menuParentId]="0"
                            (emitPass)="handleChange($event)" fxShow.gt-sm></app-top-menu>
                    </div>
                </div>
                <div fxHide.lt-md>
                    <ul class="list-inline navMenu" fxLayout="row">
                        <li class="hand-hover" *ngFor="let link of sidenavMenuItems['main_menu']">
                            <!-- [href]="link.title.href" -->
                            <a (click)="goCms(link)">{{link.title.name}}</a>
                        </li>
                        <li (click)="SearchProductsFn()" class="hand-hover" *ngIf="!!featureTags && !featureTags['sf_cms_images']"><img style="width: 26px;"
                            alt="search button" id="searchbtn"
                            src="https://hudsonmilk.com/images/3/cms/search_icon.svg"></li>
                        <li (click)="SearchProductsFn()" class="hand-hover" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                            <img style="width: 26px;" alt="search button" id="searchbtn"
                                src="assets/hudson/files/images/3/content-images/search_icon.svg"></li>
                    </ul>
                </div>
                <div fxHide.xs class="hideOnSmall">
                    <ul class="list-inline userAccout" fxLayout="row">
                        <li fxHide.gt-md class="searchIcon">
                            <button (click)="SearchProductsFn()" mat-icon-button
                                aria-label="Example icon button with a vertical three dot icon">
                                <mat-icon [ngClass]="{'increaseFontSize': shouldAddGap}">search</mat-icon>
                            </button>
                        </li>
                        <li style="margin: 0 !important;">
                            <app-top-menu *ngIf="sidenavMenuItems['desktop_links']"
                                [menuItems]="sidenavMenuItems['desktop_links']" [menuParentId]="0"
                                (emitPass)="handleChange($event)" fxShow.gt-sm></app-top-menu>
                            <!-- <a href="/login.php" class="login">Sign In</a> -->
                        </li>
                        <li class="cart-li" style="margin: 0 !important;">
                            <ng-container *ngIf="featureTags && featureTags['sf_cart_page_update']">
                                <div class="cart-action cartBtm" id="cart-link" (click)="enableRMenu()">
                                    <a [routerLink]="cartData.items > 0 ? '/edit-order' : null" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                        <img src="https://hudsonmilk.com/images/3/cms/black-basket.svg"
                                            alt="cart">                                        
                                    </a>
                                    <a [routerLink]="cartData.items > 0 ? '/edit-order' : null" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                        <img src="assets/hudson/files/images/3/content-images/black-basket.svg"
                                            alt="cart">                                        
                                    </a>
                                    <sup class="initials1 cartcount">{{cartData.items}}</sup>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="featureTags && !featureTags['sf_cart_page_update']">
                                <div [ngClass]="{'hidden': isCartOrOrdersPage()}" class="cart-action cartBtm"
                                    id="cart-link" (click)="enableRMenu()">
                                    <a [routerLink]="cartData.items > 0 ? '/edit-order' : null" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                        <img src="https://hudsonmilk.com/images/3/cms/black-basket.svg"
                                            alt="cart">
                                    </a>
                                    <a [routerLink]="cartData.items > 0 ? '/edit-order' : null" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                        <img src="assets/hudson/files/images/3/content-images/black-basket.svg"
                                            alt="cart">
                                    </a>
                                    <sup class="initials1 cartcount">{{cartData.items}}</sup>
                                </div>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- End -->
        </mat-toolbar-row>
    </mat-toolbar>

    <ng-container *ngIf="showCategories && featureTags && featureTags['sf_desktop_sub_cat']">
        <mat-toolbar [class.isHundsunMilk]="isHMTheme" id="categoriesMenu" *ngIf="Menus['sortedLinks']"
            [class.isHide]="isCmsView" fxShow.gt-sm class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
            <app-desktop-menu *ngIf="categories" [categoriesMenu]="Menus['sortedLinks']" [theme]="'hudson'"
                [allCategoriesMenu]="categories"></app-desktop-menu>
        </mat-toolbar>
    </ng-container>
    <ng-container *ngIf="showCategories && featureTags && !featureTags['sf_desktop_sub_cat']">
        <mat-toolbar [class.isHundsunMilk]="isHMTheme" id="categoriesMenu" *ngIf="Menus['sortedLinks']"
            [class.isHide]="isCmsView" fxShow.gt-sm class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
            <span *ngIf="isHMTheme" class="display hand-hover"><a style="min-width: auto;text-decoration: auto;"
                    class="hg-align" (click)="sidenav.toggle()" id="all"><i class="fa fa-bars"
                        style="margin-right: 6px;"></i>All</a></span>
            <div *ngFor="let subLinks of Menus['sortedLinks'] let i=index trackBy: trackByFn" class="pl-30">
                <!-- (window:resize)="onResize($event)" -->
                <!-- [href] to routerLink -->
                <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0"
                    [routerLink]="getUrl(!subLinks['category_url'], subLinks['category_url'], subLinks['category_url'])"
                    [id]="'link-' + (subLinks['category_name'] | lowercase)">
                    <span class="menu-title pl-5 uppercase">{{subLinks['category_name']}}</span>
                </a>
            </div>
            <!-- (window:resize)="onResize($event)"        -->
            <div *ngFor="let subLinks of Menus['title'] let i=index" class="pl-30">

                <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0"
                    [routerLink]="['/', subLinks['url']]" [id]="'link-' + i">
                    <span class="menu-title pl-5 uppercase" [innerHTML]="subLinks['title'] | sanitizeHtml"></span>
                </a>
            </div>
        </mat-toolbar>
    </ng-container>
</div>
<!-- HudsonMilk Header ends -->

<!-- [ngClass]="(router.url === '/index' || router.url === '/index') ? 'DefaultView' : 'IsProductsPage'" -->
<div class="theme-container main" [class.fullW]="isCmsView" (click)="onClickSearch()" *ngIf="router.url != '/'">
    <!-- Delivery Calendar -->
    <!-- <div class="full-width-calendar">
        <app-delivery-calendar *ngIf="loggedIn"></app-delivery-calendar>
    </div> -->
    <!-- [class.fullWidth]="isCmsView" -->
    <!-- <app-breadcrumb *ngIf="!isMobile"  [categories]="categories" [vendors] = "vendors"></app-breadcrumb> -->
    <div fxLayout="row wrap" *ngIf="router.url != '/' && router.url != '/membership-purchase' && !isMobile && router.url !== '/edit-order'">
        <div fxFlex="100" *ngIf="!isCmsView">
            <mat-card fxLayout="row" class="breadcrumb light-block">
                <a routerLink="" class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center"
                    (click)="closeSubMenus('category')">
                    <i class="material-icons homeicon" data-icon="home"></i>
                    <span class="breadcrumb-title">Homepage</span>
                </a>
                <div *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item" fxLayout="row"
                    fxLayoutAlign="start center">
                    <a [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]">{{breadcrumb.name}}</a>
                    <span [hidden]="i != (breadcrumbs.length - 1)"
                        class="breadcrumb-title active"><b>{{breadcrumb.name}}</b></span>
                </div>
            </mat-card>
        </div>
    </div>
    <!-- <router-outlet></router-outlet> -->
</div>

<!-- <app-footer></app-footer> -->
<!-- </mat-sidenav-container> -->

<div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" class="back-to-top transition">
    <button mat-icon-button (click)="scrollToTop()" style="background-color: white;">
        <mat-icon class="align-font">arrow_upward</mat-icon>
    </button>
</div>